(function () {
  var DEFAULT_INTERVAL = 10000;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function restartFill(tick, running) {
    var fill = tick.querySelector('.hero-toast__tick-fill');
    if (!fill) return;
    fill.style.animation = 'none';
    fill.style.transform = '';
    void fill.offsetWidth;
    if (running && !prefersReducedMotion()) {
      fill.style.animation = '';
    }
  }

  function initToast(root) {
    if (!root || root.dataset.heroToastBound === 'true') return;

    var slides = root.querySelectorAll('[data-hero-toast-slide]');
    var ticks = root.querySelectorAll('[data-hero-toast-tick]');
    if (slides.length < 2) return;

    root.dataset.heroToastBound = 'true';

    var index = 0;
    var timer = null;
    var interval = Number(root.getAttribute('data-hero-toast-interval')) || DEFAULT_INTERVAL;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });
      ticks.forEach(function (tick, i) {
        tick.classList.toggle('is-active', i === index);
        restartFill(tick, i === index);
      });
    }

    function start() {
      if (timer) window.clearInterval(timer);
      if (prefersReducedMotion() || interval < 1) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, interval);
    }

    show(0);
    start();
  }

  function pauseVideos(scope) {
    if (!prefersReducedMotion()) return;
    var root = scope || document;
    root.querySelectorAll('[data-hero-homepage] video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  function initAll(scope) {
    var root = scope || document;
    pauseVideos(root);
    root.querySelectorAll('[data-hero-toast]').forEach(initToast);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-hero-toast]')) {
      initAll(event.target);
    }
  });
})();
